import { Content_Block } from "../ContentBlock";

export class RecapBlock extends Content_Block{
    constructor(){
        super("recap");
        this.icon = "running";
        this.title = ""
        this.value = "";
        
    }
}